import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
 import Rprogramtemplate from "../../component/course/rprogram";

export default class Rprograminmadurai extends Component {
 
  render() {
   
    const title = "R Programming"
    const url= "rprogram"
     const url1 ="-training-in-madurai"
    const location = "madurai" 
    const location1="Training in Madurai"
     return(
      <>
          <NextSeoModule
          title={`${title} ${location1} - learnsoft.org`}
            description={`Join Learnsoft.org ${location} R Programming training program and become an expert in the technology. Our expert trainers provide hands-on experience to help you excel in your field.`}
            url={`${location}/${url}${url1}`}
           img={`course/${url}.webp`}
             keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}
          />
        <Layout navbarBackgroundColor="#281E1E">
          <Rprogramtemplate url1={url1} title={title} url={url} relatedlocation={location} location={location} location1={location1} />
         </Layout>
      </>
    );
  }
}
